import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    warningMessages: String,
  };

  connect() {
    this.tooltip = new bootstrap.Tooltip(this.element, {
      title: this.warningMessagesValue,
      placement: this.element.dataset.bsPlacement || 'right',
      delay: { show: 250, hide: 500 },
    });
  }
}
